import { Booked } from './components/Booked';
import { Arrived } from './components/Arrived';
import { AlreadyInUk } from './components/AlreadyInUk';
import { ITravelStatus } from '../../../../../types';
import { None } from './components/None';
import { Defer } from './components/Defer';
import { Withdraw } from './components/Withdraw';
import { TravelPrevented } from './components/TravelPrevented';
import { TravelCancelled } from './components/TravelCancelled';
import { TravelStatusEnum } from 'api-paths-cas';

interface IProps {
  status: ITravelStatus['status'];
  setComplete: (status: boolean) => void;
  travelStatus: ITravelStatus;
  additionalAnswers: {
    answers: Omit<ITravelStatus, 'status'>;
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
  setIsEdited: () => void;
}

export const AdditionalQuestions = (props: IProps) => {
  const {
    status,
    travelStatus,
    additionalAnswers: { setAnswers },
    setComplete,
    setIsEdited,
  } = props;

  const travelStatus_status = status || TravelStatusEnum.None;

  switch (travelStatus_status) {
    case TravelStatusEnum.None: {
      return <None setComplete={setComplete} />;
    }
    case TravelStatusEnum.NoBookingYet: {
      return <None setComplete={setComplete} />;
    }
    case TravelStatusEnum.Booked: {
      return (
        <Booked
          setIsEdited={setIsEdited}
          travelStatus={travelStatus}
          additionalAnswers={{ setAnswers }}
          setComplete={setComplete}
        />
      );
    }
    case TravelStatusEnum.Arrived: {
      return (
        <Arrived
          setIsEdited={setIsEdited}
          travelStatus={travelStatus}
          additionalAnswers={{ setAnswers }}
          setComplete={setComplete}
        />
      );
    }
    case TravelStatusEnum.Defer: {
      return (
        <Defer
          setIsEdited={setIsEdited}
          travelStatus={travelStatus}
          additionalAnswers={{ setAnswers }}
          setComplete={setComplete}
        />
      );
    }
    case TravelStatusEnum.Withdraw: {
      return (
        <Withdraw
          setIsEdited={setIsEdited}
          travelStatus={travelStatus}
          additionalAnswers={{ setAnswers }}
          setComplete={setComplete}
        />
      );
    }
    case TravelStatusEnum.TravelPrevented: {
      return (
        <TravelPrevented
          setIsEdited={setIsEdited}
          travelStatus={travelStatus}
          additionalAnswers={{ setAnswers }}
          setComplete={setComplete}
        />
      );
    }
    case TravelStatusEnum.TravelCancelled: {
      return (
        <TravelCancelled
          setIsEdited={setIsEdited}
          travelStatus={travelStatus}
          additionalAnswers={{ setAnswers }}
          setComplete={setComplete}
        />
      );
    }
    case TravelStatusEnum.AlreadyInUk: {
      return <AlreadyInUk setComplete={setComplete} />;
    }

    default: {
      return <></>;
    }
  }
};
